package redmcrosco.alex.farmatch.ui

import androidx.compose.runtime.*

// Common part
@Composable
fun AppEnvironment(language: String?, content: @Composable () -> Unit) {
    CompositionLocalProvider(
        LocalAppLocale provides language,
    ) {
        key(language) {
            content()
        }
    }
}

expect object LocalAppLocale {
    @Composable
    infix fun provides(value: String?): ProvidedValue<*>
}
